import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";

@Injectable()
export class ChangeCollisionDialogComponentService {
    
    private _oldStatus = new ReplaySubject(1);
    private _newStatus = new ReplaySubject(1);

    oldStatus$: Observable<any> = this._oldStatus.asObservable();
    newStatus$: Observable<any> = this._newStatus.asObservable();

    constructor(){ }

    setOldStatus = (status) => this._oldStatus.next(status);
    setNewStatus = (status) => this._newStatus.next(status);

}